import { Application } from '@hotwired/stimulus'
import LiveController from '@symfony/ux-live-component'

import './base/index.less'
import './blocks/index.less'
import './components/index.less'
import './base/utils.less'

const app = Application.start()
app.register('live', LiveController)

function toKebabControllerName(rawName: string): string {
    const tokens = rawName.split('/').filter(Boolean)
    return tokens
        .map((symbol) => symbol.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase())
        .join('-')
}

// @ts-ignore
const behaviors = import.meta.glob(['./behaviors/**/*.ts', '!./behaviors/**/*.d.ts'], { eager: true }) as Record<string, any>

for (const path in behaviors) {
    const controllerModule = behaviors[path]

    if (!controllerModule?.default) {
        continue
    }

    let rawName = path.replace('./behaviors/', '').replace(/\.ts$/, '')

    app.register(toKebabControllerName(rawName), controllerModule.default)
}

// @ts-ignore
const components = import.meta.glob('./components/**/controller.ts', { eager: true }) as Record<string, any>

for (const path in components) {
    const controllerModule = components[path]

    if (!controllerModule?.default) {
        continue
    }

    const rawName = path.replace('./components/', '').replace('/controller.ts', '')

    app.register(toKebabControllerName(rawName), controllerModule.default)
}

// @ts-ignore
const blocks = import.meta.glob('./blocks/**/controller.ts', { eager: true }) as Record<string, any>

for (const path in blocks) {
    const controllerModule = blocks[path]

    if (!controllerModule?.default) {
        continue
    }

    const rawName = path.replace('./blocks/', '')
        .replace('/controller.ts', '')

    app.register(toKebabControllerName(rawName), controllerModule.default)
}